import React, { useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import ListPageHeader from '@shared/ListPageHeader'
import OrderHoldList from '@shared/orders/OrderHoldList'
import OrderHoldConceptModal from '@shared/orders/OrderHoldConceptModal'
import { orderHoldService } from '@services/admin/orderHoldService'

export default function List() {
  const { t } = useTranslation()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.order_holds']}
        actions={
          <Button
            type="text"
            size="small"
            icon={<QuestionCircleOutlined />}
            onClick={() => setConceptModalVisible(true)}
            style={{ color: '#8c8c8c' }}
          >
            {t('concepts.order_holds.tooltip')}
          </Button>
        }
      />
      <OrderHoldList
        service={orderHoldService}
        role="admin"
        merchants={[]}
      />
      <OrderHoldConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
